enum NavbarMessageType {
  COMPANY = 'companyRequest',
  MFA_NOTIFICATION = 'mfaNotification',
  DEVICE_LOCATION = 'deviceLocation',
  COMPANY_VAT = 'companyVat',
  ANNOUNCEMENT = 'announcement'
}

export default NavbarMessageType
